import React from 'react';
import { SVGS } from '@zonofi/zono-money-design-system';
import {
  CatalogListData,
  dispatch,
  getIsSimulation,
  LineInOrder,
  Seller,
  updateCurrentTooltipIndex,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { TailSpin } from 'react-loader-spinner';
import _ from 'lodash';

interface RenderAddButtonProps {
  item: CatalogListData; // Replace with the actual type for `item`
  seller: Seller; // Replace with the actual type for `seller`
  inviteId: string; // Adjust type if it's not a string
  quantityMap: Record<number, any>; // Adjust based on the structure of `quantityMap`
  setQuantityMap: React.Dispatch<React.SetStateAction<Record<number, any>>>;
  onDelete: (
    item: LineInOrder,
    sellerWorkspaceId: string,
    customerId: string
  ) => any;
  onDecrement: (
    item: LineInOrder,
    sellerWorkspaceId: string,
    customerId: string
  ) => any;
  onChangeQuantity: (
    item: LineInOrder,
    newQty: number,
    sellerWorkspaceId: string,
    customerId: string
  ) => any;
  onIncrement: (
    item: LineInOrder,
    sellerWorkspaceId: string,
    customerId: string
  ) => any;
  onAddToCart: (item: CatalogListData) => any;
  listView: boolean;
  parentInfo: {
    isParent: boolean;
    isAddedToCart: boolean;
    accQty: number;
    onClick: () => void;
  };
  showOutOfStack?: boolean;
  setShowOutofStockError?: (val: boolean) => void;
}

export const RenderAddButton: React.FC<RenderAddButtonProps> = ({
  item,
  onDelete,
  seller,
  inviteId,
  onDecrement,
  onChangeQuantity,
  quantityMap,
  setQuantityMap,
  onIncrement,
  onAddToCart,
  listView,
  parentInfo,
  showOutOfStack,
  setShowOutofStockError,
}) => {
  const isSimulation = useAppSelector(getIsSimulation);
  const onClickAddBtn = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (item?.isLoading) {
      return;
    }

    e.stopPropagation();

    if (parentInfo?.isParent) {
      parentInfo?.onClick();
    } else {
      onAddToCart(item);
    }
  };

  if (parentInfo?.isParent) {
    return parentInfo?.isAddedToCart ? (
      <button
        className={`catalog-list-item${listView ? '-grid-' : '-'}add-to-cart catalog-list-item${
          listView ? '-grid-' : '-'
        }add-to-cart-active font-primary-semibold`}
        onClick={(e) => onClickAddBtn(e)}
      >
        <img src={SVGS.CartSmall} />
        <span>{parentInfo?.accQty}</span>
        <img src={SVGS.RightArrowBlue} />
      </button>
    ) : (
      <button
        className={`catalog-list-item${listView ? '-grid-' : '-'}add-to-cart font-primary-semibold`}
        onClick={(e) => {
          if (isSimulation) {
            dispatch(updateCurrentTooltipIndex(1));
          }
          onClickAddBtn(e);
        }}
      >
        <span>View</span>
      </button>
    );
  }
  return item?.isAddedToCart ? (
    <div
      className={`catalog-list-item${listView ? '-grid-' : '-'}qty-selector-container`}
    >
      <div className={`catalog-list-item${listView ? '-grid-' : '-'}delete`}>
        {item?.isDeleting ? (
          <div className="catalog-list-item-qty-selector-loader">
            <TailSpin width={15} />
          </div>
        ) : (
          <img
            src={SVGS.DeleteRed}
            alt="delete"
            width={20}
            height={20}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(item?.lineInOrder, seller?.workspaceId, inviteId);
            }}
          />
        )}
      </div>

      <div
        className={`catalog-list-item${listView ? '-grid-' : '-'}qty-selector`}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={SVGS.MinuxIconBlue}
          alt="semi-quantity-selector"
          onClick={(e) => {
            e.stopPropagation();
            onDecrement(item?.lineInOrder, seller?.workspaceId, inviteId);
          }}
        />
        {item?.isLoading ? (
          <div className="catalog-list-item-qty-selector-loader">
            <TailSpin width={15} />
          </div>
        ) : (
          <input
            className={`catalog-list-item${
              listView ? '-grid-' : '-'
            }qty-selector-input font-primary-semibold`}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*[.,]?[0-9]+"
            key={item?.productVariantId}
            onKeyDown={(e) => {
              onChangeQuantity(
                item?.lineInOrder,
                quantityMap[item?.productVariantId],
                seller?.workspaceId,
                inviteId
              );
            }}
            onBlur={() => {
              onChangeQuantity(
                item?.lineInOrder,
                quantityMap[item?.productVariantId],
                seller?.workspaceId,
                inviteId
              );
            }}
            onChange={(e) => {
              if (!isNaN(Number(e.target.value))) {
                const initialQuantiyMap = quantityMap;
                if (item?.productVariantId) {
                  initialQuantiyMap[item?.productVariantId] = Number(
                    e.target.value
                  );
                }
                setQuantityMap({ ...initialQuantiyMap });
              }
            }}
            value={quantityMap[item?.productVariantId]}
          />
        )}
        <img
          src={SVGS.AddIconBlue}
          alt="add-quantity"
          onClick={(e) => {
            e.stopPropagation();
            onIncrement(item?.lineInOrder, seller?.workspaceId, inviteId);
            // if (
            //   showOutOfStack &&
            //   quantityMap[item?.productVariantId] >= item?.stock
            // ) {
            //   setShowOutofStockError(true);
            // } else {
            //   setShowOutofStockError(false);

            // }
          }}
        />
      </div>
    </div>
  ) : showOutOfStack && item?.stock < 1 ? (
    <button
      className={`catalog-list-item${listView ? '-grid-' : '-'}add-to-cart-disabled font-primary-semibold`}
    >
      <span>Add</span>
    </button>
  ) : (
    <button
      className={`catalog-list-item${listView ? '-grid-' : '-'}add-to-cart font-primary-semibold`}
      onClick={(e) => {
        onClickAddBtn(e);
        if (isSimulation) {
          dispatch(updateCurrentTooltipIndex(1));
        }
      }}
    >
      {item?.isLoading ? <TailSpin width={15} /> : <span>Add</span>}
    </button>
  );
};
